<template>
    <div class="form-group" :class="{ 'form-row': horizontal }">
        <label
            v-if="label"
            :class="[
                { 'col-form-label': horizontal },
                horizontal ? class_label : '',
            ]"
            >{{ label }}</label
        >
        <div :class="[horizontal ? class_input : '']">
            <multiselect
                :class="{ 'is-invalid': isValid == false }"
                v-model="valueComponent"
                tag-placeholder="Add this as new tag"
                :placeholder="placeholder"
                :track-by="optionsValue"
                :label="optionsLabel"
                :options="options"
                :disabled="disabled"
                :max="max"
                :multiple="true"
                :taggable="false"
            ></multiselect>
        </div>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import ArrayUtils from "~/utils/arrays";

export default {
    name: "SelectTagsComponent",
    components: {
        Multiselect,
    },
    data() {
        return {
            // item_select: [],
            valueComponent: [],
            class_label: "col-sm-3",
            class_input: "col-sm-9",
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: "Select item",
        },
        isValid: {
            type: Boolean,
            default: null,
        },
        value: {
            default: null,
        },
        onlyValue: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: [],
        },
        optionsValue: {
            type: String,
            default: "value",
        } /* valueAttribute */,
        optionsLabel: {
            type: String,
            default: "name",
        } /* valueName */,
        horizontal: {
            default: false,
        },
        max:{
            default: null
        },
        disabled:{
            default:false
        }
    },
    watch: {
        // item_select(newValue) {
        //     this.$emit("update:value", newValue);
        //     this.$emit("change", newValue);
        // },
        valueComponent(newValue, oldValue) {

            const newValueAsOption = this.mappingValuesAsOption({
                values: newValue,
                onlyValue: false,
            });

            if (this.onlyValue) {
                newValue = newValueAsOption.map((value) => {
                    return value[this.optionsValue];
                });
            }

            this.$emit("update:value", newValue);
            this.$emit("change", newValue);
        },
        value(newValue, oldValue) {
            if (!ArrayUtils.areSetsEqual(newValue, oldValue)) {
                this.valueComponent = this.mappingValuesAsOption({
                    values: newValue,
                    onlyValue: this.onlyValue,
                });
            }
        },
    },
    methods: {
        setHorizontalClass: function () {
            if (this.horizontal.label) {
                this.class_label = this.horizontal.label;
            }
            if (this.horizontal.input) {
                this.class_input = this.horizontal.input;
            }
        },
        // addTag(newTag) {
        //     const tag = {
        //         value: newTag,
        //         name:
        //             newTag.substring(0, 2) +
        //             Math.floor(Math.random() * 10000000),
        //     };
        //     this.options.push(tag);
        //     this.item_select.push(tag);
        // },

        propValueIsOnlyValues() {
            // Verifica si el valor es de tipo objeto, no es null, no es un array y es una instancia de Object.
            const firstValue = this.value[0];
            if (
                typeof firstValue === "object" &&
                !Array.isArray(firstValue) &&
                firstValue instanceof Object
            ) {
                return false;
            } else {
                return true;
            }
        },

        mappingValuesAsOption({ values, onlyValue }) {
            // Hacemos un mapping de los values según el formato que vienen en las opciones.
            // En caso de que una value no se encuentra entre las opciones se quita del listado.
            if (!values) return [];
            return values.map((value) => {
                const valueToFind =
                    onlyValue && this.propValueIsOnlyValues()
                        ? value
                        : value[this.optionsValue];
                return this.options.find((option) => {
                    return option[this.optionsValue] == valueToFind;
                });
            }).filter((option) => option !== undefined);
        },
    },
    async mounted() {
        this.setHorizontalClass();
        // this.item_select = this.value;
        this.valueComponent = this.mappingValuesAsOption({
            values: this.value,
            onlyValue: this.onlyValue,
        });
    },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap.scss";

/**.multiselect.is-invalid {
    .multiselect__tags {
        @extend .form-control.is-invalid;
    }
} */
</style>
